import { Injectable } from "@angular/core";
import { OrganisationConnector } from "./organisation.connector";
import { AppServerOrganisationConnector } from "../../app-server-connectors";
import { AuthenticationService, CachingService, IAMService, UIService } from "src/app/services/services.module";
import { APIResponse, OrganisationDocument, UserDocument } from "server-model";

@Injectable()
export class OrganisationDataService {
    private organisationConnector: OrganisationConnector;

    constructor(
        private cachingService: CachingService,
        private iamService: IAMService,
        private authenticationService: AuthenticationService,
        private uiService: UIService,
    ) {
        this.organisationConnector = new AppServerOrganisationConnector(this.iamService, this.authenticationService, this.uiService)
    }

    async getOrganisation(organisationId: string): Promise<APIResponse> {
        const response = await this.organisationConnector.getOrganisation(organisationId);
        return response;
    }
    async createOrganisation(organisationDocument: OrganisationDocument): Promise<APIResponse> {
        const response = await this.organisationConnector.createOrganisation(organisationDocument);
        return response;
    }
    async updateOrganisation(organisationId: string, organisationDocument: OrganisationDocument): Promise<APIResponse> {
        const response = await this.organisationConnector.updateOrganisation(organisationId, organisationDocument);
        return response;
    }
    async deleteOrganisation(organisationId: string): Promise<APIResponse> {
        const response = await this.organisationConnector.deleteOrganisation(organisationId);
        return response;
    }
    async listOrganisationUsers(organisationId: string): Promise<APIResponse> {
        const response = await this.organisationConnector.listOrganisationUsers(organisationId);
        return response;
    }
}
